export const UPI_STATUS = [
  { label: '完成', key: 'Complete', eLabel: 'Complete' },
  { label: '保留', key: 'Hold', eLabel: 'Hold' },
  { label: '错误', key: 'Error', eLabel: 'Error' },
  { label: '进行中', key: 'In Progress',  eLabel: 'In Progress' },
  { label: '预接收', key: 'Pre-Received', eLabel: 'Pre-Received' },
  { label: '发布', key: 'Released',  eLabel: 'Released' },
];
